import _ from 'underscore'
import accounting from 'accounting'

/**
 * @mixin
 */
export default {
    data: () => ({
        defaultMinLength: 8,
        defaultMaxLength: 100
    }),
    computed: {
        addressOptions: () => ({
            postcodeMinLength: 6,
            postcodeMaxLength: 8
        }),
        characterOptions () {
            const vm = this
            return {
                minLength: vm.defaultMinLength,
                maxLength: vm.defaultMaxLength
            }
        },
        passwordOptions () {
            const vm = this
            return {
                minLength: vm.defaultMinLength,
                maxLength: vm.defaultMaxLength,
                minNumbers: 0,
                minSymbols: 0,
                minLowercase: 0,
                minUppercase: 0
            }
        },
        phoneNumberOptions () {
            const vm = this
            return {
                numberLength: 10,
                minDigits: vm.defaultMinLength
            }
        },
        validationRules () {
            const vm = this
            return {
                generic: {
                    required: v => {
                        v = _.isString(v) ? v.trim() : v
                        return !_.isEmpty(v) || typeof v === 'number' || 'Required'
                    },
                    alphanumeric: v => _.isEmpty(v) || (!!v.match(/^[0-9a-z\s]+$/i)) || 'Field must only contain alphanumeric characters and spaces',
                    integersOnly: v => _.isEmpty(v) || /^\d+$/.test(v) || 'Positive integer values only',
                    // Please use `validationRules.characters.minlength` and `validationRules.characters.maxLength` instead of the two deprecated and hardcoded limit rules below
                    min8Characters: v => _.isEmpty(v) || v.length >= 8 || 'Min. 8 characters',
                    max20Characters: v => _.isEmpty(v) || v.length <= 20 || 'Max. 20 characters',
                    nonZero: v => v != 0 || 'Field cannot be zero',
                    noLetters: v => _.isEmpty(v) || (!/[\D]/.test(v.slice(1))) || 'Field cannot contain letters'
                },
                address: {
                    postcodeMinLength: v => _.isEmpty(v) || v.length >= vm.addressOptions.postcodeMinLength || `Postcode must be at least ${vm.addressOptions.postcodeMinLength} characters long`,
                    postcodeMaxLength: v => _.isEmpty(v) || v.length <= vm.addressOptions.postcodeMaxLength || `Postcode must not exceed ${vm.addressOptions.postcodeMaxLength} characters`
                },
                accounting: {
                    nonZero: v => v !== '£0.00' || 'Must have a cost',
                    maxValue: v => {
                        const maxValue = 1000000000
                        return accounting.unformat(v) <= maxValue || `This value should not exceed ${accounting.formatNumber(maxValue)}`
                    },
                    money: v => _.isEmpty(v) || /^[\d,]*$/.test(v) && (v.match(/\./g) || []).length <= 1 || 'Field must contain only numbers and commas'
                },
                characters: {
                    minLength: v => _.isEmpty(v) || v.length >= vm.characterOptions.minLength || `Must be at least ${vm.characterOptions.minLength} characters long`,
                    maxLength: v => _.isEmpty(v) || v.length <= vm.characterOptions.maxLength || `Must not exceed ${vm.characterOptions.maxLength} characters`
                },
                company: {
                    registrationNumber: (v) => _.isEmpty(v) || v.length === 8 && !/[^a-z0-9]/i.test(v)|| 'Company Registration Number should contain 8 alphanumeric characters'
                },
                email: {
                    valid: v => _.isEmpty(v) || (v.includes('@') && v.includes('.')) || 'Email must contain an \'@\' and a \'.\' character',
                    minLength: v => _.isEmpty(v) || v.length >= 6 || 'Email must be at least 6 characters long'
                },
                password: {
                    mustContainNumber: v => _.isEmpty(v) || /\d/.test(v) || 'Password must contain a number',
                    mustContainLetter: v => _.isEmpty(v) || /[a-z]/i.test(v) || 'Password must contain a letter',
                    mustContainLowecaseLetter: v => _.isEmpty(v) || /[a-z]/.test(v) || 'Password must contain a lowercase letter',
                    mustContainUppercaseLetter: v => _.isEmpty(v) || /[A-Z]/.test(v) || 'Password must contain an uppercase letter',
                    mustContainSpecialCharacter: v => _.isEmpty(v) || /[^a-z0-9]/i.test(v) || 'Password must contain a special character',
                    minLength: v => _.isEmpty(v) || v.length >= vm.passwordOptions.minLength || `Password must be at least ${vm.passwordOptions.minLength} characters long`,
                    maxLength: v => _.isEmpty(v) || v.length <= vm.passwordOptions.maxLength || `Password must not exceed ${vm.passwordOptions.maxLength} characters`,
                    minNumbers: v => _.isEmpty(v) || v.replace(/[\D]/g, '').length >= vm.passwordOptions.minNumbers || `Min. ${vm.passwordOptions.minNumbers} number(s)`,
                    minSymbols: v => _.isEmpty(v) || v.replace(/[a-z0-9]/gi, '').length >= vm.passwordOptions.minSymbols || `Min. ${vm.passwordOptions.minSymbols} symbol(s)`,
                    minLowercase: v => _.isEmpty(v) || v.replace(/[^a-z]/g, '').length >= vm.passwordOptions.minLowercase || `Min. ${vm.passwordOptions.minLowercase} lowercase letter(s)`,
                    minUppercase: v => _.isEmpty(v) || v.replace(/[^A-Z]/g, '').length >= vm.passwordOptions.minUppercase || `Min. ${vm.passwordOptions.minUppercase} uppercase letter(s)`
                },
                phoneNumber: {
                    startPlus44: v => _.isEmpty(v) || v.substr(0, 3) === '+44' || 'Phone number must begin with +44',
                    twelveDigits: v => _.isEmpty(v) || (v.match(/\d/g) || []).length === 12 || 'Phone number must contain 12 digits',
                    minDigits: v => _.isEmpty(v) || (v.match(/\d/g) || []).length >= vm.phoneNumberOptions.minDigits || `Number must be at least ${vm.phoneNumberOptions.minDigits} digits long`,
                    numberLength: v => _.isEmpty(v) || (v.match(/\d/g) || []).length === vm.phoneNumberOptions.numberLength || `Number must be ${vm.phoneNumberOptions.numberLength} digits long`,
                    noLetters: v => _.isEmpty(v) || !/[\D]/.test(v.slice(1)) || 'Phone number must only contain digits'
                }
            }
        }
    }
}
